import React, { useEffect, useState } from 'react';

export interface SectionNavItem {
  id: string;
  label: string;
}

export interface SectionNavProps {
  data: {
    items: SectionNavItem[];
  };
}

export const SectionNav: React.FC<SectionNavProps> = ({ data: { items } }) => {
  const [activeId, setActiveId] = useState(items[0]?.id);
  const itemsKey = items.map((item) => item.id).join('|');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveId(entry.target.id);
        }),
      { rootMargin: '-80px 0px -60% 0px' }
    );
    itemsKey.split('|').forEach((id) => {
      const element = document.getElementById(id);
      if (element) observer.observe(element);
    });
    return () => observer.disconnect();
  }, [itemsKey]);

  const scrollTo = (event: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    event.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav className="sticky top-0 z-40 bg-neutral-0 border-b border-gray-200">
      <div className="flex gap-[28px] overflow-x-auto overflow-y-hidden [scrollbar-width:none] [&::-webkit-scrollbar]:hidden px-[clamp(16px,3vw,48px)] max-w-[1440px] mx-auto">
        {items.map((item) => (
          <a
            key={item.id}
            href={`#${item.id}`}
            onClick={(event) => scrollTo(event, item.id)}
            className={`py-[16px] border-b-2 whitespace-nowrap text-[14px] font-gilroy-medium no-underline hover:no-underline focus:no-underline outline-none focus:outline-none focus-visible:text-neutral-500 ${
              activeId === item.id
                ? 'border-neutral-500 text-neutral-500'
                : 'border-transparent text-neutral-300 hover:text-neutral-500'
            }`}
          >
            {item.label}
          </a>
        ))}
      </div>
    </nav>
  );
};
